import dayBatchService from "../services/dayBatch.service";

const dayBatches = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, dayBatch) {
            return dayBatchService.create(dayBatch);
        },
        generateCoverPage(_, dayBatchId) {
            return dayBatchService.generateCoverPage(dayBatchId);
        },

        //READ
        get(_, params) {
            return dayBatchService.get(params.id, params.urlParameters, params.requestId);
        },
        getpostsubmissionreducedview(_, params) {
            return dayBatchService.getpostsubmissionreducedview(params.id, params.urlParameters, params.requestId);
        },
        getDayBatchPostSubmissionFormDto(_, params) {
            return dayBatchService.getDayBatchPostSubmissionFormDto(params.id, params.requestId);
        },
        //UPDATE
        update(_, params) {
            return dayBatchService.update(params.id, params.formData);
        },
        setCoverPrintedVerified(_, params) {
            return dayBatchService.setCoverPrintedVerified(params.id, params.isPrintedVerified);
        },
        setisprocessed(_, params) {
            return dayBatchService.setisprocessed(params.id, params.isProcessed);
        },
        setreturnedcoverdocument(_, params) {
            return dayBatchService.setreturnedcoverdocument(params.id, params.formData);
        },

        //DELETE
        delete(_, id) {
            return dayBatchService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default dayBatches;
